var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 106,
    viewBox: "0 0 115 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_2792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 17.1C28.75 6.9 42.35 0.5 57.45 0.5C79.95 0.5 99.15 14.7 106.45 34.7",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7496 89.4C85.2496 99 72.0496 105 57.4496 105C34.3496 105 14.6496 90 7.84961 69.1",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0498 86.5L7.0498 67.2L25.5498 75.2",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.95 16.4L107.15 35.4L88.9502 26.7",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0498 54.8C32.0498 52.8 31.0498 50.3 31.0498 47.2C31.0498 44.1 32.0498 41.6 34.0498 39.6C36.0498 37.6 38.5498 36.6 41.5498 36.6C43.6498 36.6 45.5498 37.1 47.2498 38C48.9498 39 50.1498 40.4 50.9498 42.2H48.3498C47.7498 41 46.7498 40 45.5498 39.4C44.3498 38.7 42.9498 38.4 41.4498 38.4C39.0498 38.4 37.0498 39.2 35.4498 40.8C33.8498 42.4 33.0498 44.5 33.0498 47.1C33.0498 49.7 33.8498 51.8 35.4498 53.4C37.0498 55 39.0498 55.8 41.4498 55.8C42.9498 55.8 44.3498 55.5 45.5498 54.8C46.7498 54.1 47.6498 53.2 48.3498 52H50.9498C50.1498 53.8 48.8498 55.2 47.2498 56.2C45.5498 57.2 43.7498 57.6 41.5498 57.6C38.5498 57.8 36.0498 56.8 34.0498 54.8Z",
    fill: "#4C9B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9502 54.9C59.9502 52.9 58.9502 50.4 58.9502 47.2999C58.9502 44.1999 59.9502 41.7 61.9502 39.7C63.9502 37.7 66.4502 36.7 69.4502 36.7C72.4502 36.7 74.9502 37.7 76.9502 39.7C78.9502 41.7 79.9502 44.1999 79.9502 47.2999C79.9502 50.4 78.9502 52.9 76.9502 54.9C74.9502 56.9 72.4502 57.9 69.4502 57.9C66.4502 57.8 63.9502 56.8 61.9502 54.9ZM75.4502 53.5999C77.0502 51.9999 77.8502 49.9 77.8502 47.2999C77.8502 44.6999 77.0502 42.6 75.4502 41C73.8502 39.4 71.8502 38.5999 69.4502 38.5999C67.0502 38.5999 65.0502 39.4 63.4502 41C61.8502 42.6 61.0502 44.6999 61.0502 47.2999C61.0502 49.9 61.8502 51.9999 63.4502 53.5999C65.0502 55.1999 67.0502 56 69.4502 56C71.8502 56 73.8502 55.1999 75.4502 53.5999Z",
    fill: "#4C9B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9502 76.6V75.6C76.2502 75.3 76.7502 74.9 77.3502 74.4C77.9502 73.9 78.4502 73.5 78.7502 73.2C79.0502 72.9 79.4502 72.5 79.9502 72.1C80.4502 71.6 80.8502 71.2 81.1502 70.9C81.4502 70.6 81.7502 70.2 82.1502 69.8C82.5502 69.4 82.7502 69 82.9502 68.6C83.3502 67.8 83.5502 66.9 83.5502 66.1C83.5502 65.3 83.3502 64.6 82.8502 64C82.3502 63.4 81.6502 63.2 80.5502 63.2C79.5502 63.2 78.7502 63.5 78.1502 64.1C77.5502 64.7 77.2502 65.5 77.2502 66.6H75.9502C76.0502 65.1 76.4502 64 77.2502 63.2C78.0502 62.4 79.1502 62 80.4502 62C81.7502 62 82.8502 62.4 83.6502 63.1C84.4502 63.8 84.8502 64.9 84.8502 66.2C84.8502 66.8 84.7502 67.4 84.4502 68C84.2502 68.6 83.9502 69.2 83.6502 69.7C83.3502 70.2 82.9502 70.7 82.3502 71.3C81.7502 71.9 81.3502 72.4 80.9502 72.7C80.5502 73 80.0502 73.5 79.4502 74.1C78.7502 74.7 78.3502 75.1 78.1502 75.2H85.3502V76.4H75.9502V76.6Z",
    fill: "#4C9B5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_2792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.9,
    height: 105.5,
    fill: "white",
    transform: "translate(0.549805)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/co2.3a4d5310ac874cebec791c82b781f9a0.svg";
export { ForwardRef as ReactComponent };